import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { Section } from 'jbc-front/components/Form';
import { getItem } from 'src/reducers/common/itemReducer';
import selector from 'src/utils/Utils';
import DefaultValue from './DefaultValue';

import PaymentItem from './PaymentItem';

const changeOrderOfGenkinToLast = paymentBanks => {
  const genkinTransfer = _.filter(paymentBanks, { paymentOrder: 'fourth' });
  const bankTransfers = _.reject(paymentBanks, { paymentOrder: 'fourth' }) || [];
  if (genkinTransfer.length === 1 && bankTransfers.length >= 0) {
    bankTransfers.push(genkinTransfer[0]);
  }
  return bankTransfers;
};

const PaymentBanksSectionShow = ({ payPaymentBanks, bonusPaymentBanks }) => {
  if ((payPaymentBanks && payPaymentBanks.length > 0) || (bonusPaymentBanks && bonusPaymentBanks.length > 0)) {
    // 現金は最後尾にレンダリングしたいので順番を入れ替える
    const payrollPayments = changeOrderOfGenkinToLast(payPaymentBanks);

    // const bonusPayments = changeOrderOfGenkinToLast(bonusPaymentBanks);
    const { t } = useTranslation();
    return (
      <div>
        <Section title={t('components.SideMenu.SideMenu.salary')}>
          {_.map(payrollPayments, item => <PaymentItem item={item} key={item.id} />)}
        </Section>
        {/* <Section title={t('components.SideMenu.SideMenu.bonus')}>{_.map(bonusPayments, item => <PaymentItem item={item} key={item.id} />)}</Section> */}
      </div>
    );
  }
  return <DefaultValue />;
};

const mapStateToProps = state => ({
  payPaymentBanks: selector(getItem(REDUCER_NAME, state), 'payPaymentBanks') || []
});

export default connect(mapStateToProps)(PaymentBanksSectionShow);
